import moment from 'moment-timezone';

const currentYear = Number(moment.utc().format('YYYY'));

export function calculateVehicleAge(
  vehicle: { year?: number },
  baseVehicleYear = currentYear
) {
  return Math.max(baseVehicleYear - (vehicle?.year || currentYear), 0);
}
